module.exports = __webpack_public_path__ + "img/hbzupanija.d548a11e.png";